import type { Platform } from './types';

/**
 * Detects the current platform (web, ios, android) using Capacitor if available.
 */
export function detectPlatform(): Platform {
  try {
    // Capacitor exposes itself on the window object
    const cap = (window as any).Capacitor;
    if (cap?.isNativePlatform?.()) {
      const platform = cap.getPlatform?.();
      if (platform === 'ios') return 'ios';
      if (platform === 'android') return 'android';
    }
  } catch {
    // Not in a Capacitor environment
  }
  return 'web';
}
